// Weights reflect measured matching impact (local-docs/product_profile_data_audit.md):
// capabilities_description + reference_projects ground the HyDE main vector, and
// profiles missing them were the worst-case matching inputs in the July 2026
// score investigation — the completeness meter used to ignore both.
// CPV 2008 codes are 8 digits. Shorter entries ("50", "454") are truncated
// fragments from the legacy free-entry path: padded out they claim a whole
// division, which can never clear the specificity gate in matching, so they
// contribute nothing. Counting them as "CPV areas selected" let a profile read
// as complete while being unmatchable — mirrors usable_cpv_codes() in
// backend/profiles/health.py, minus the official-table check the frontend
// can't do.
const isUsableCpv = (code) => String(code ?? '').replace(/\D/g, '').length === 8;

const FIELDS = [
  { key: 'profile_name',             weight: 5,  label: 'Profile name',             check: (p) => !!(p?.profile_name?.trim()) },
  { key: 'specialisations',          weight: 20, label: 'Specialisations',          check: (p) => (p?.specialisations || []).length > 0 },
  { key: 'capabilities_description', weight: 20, label: 'Capabilities description', check: (p) => !!(p?.capabilities_description?.trim()) },
  { key: 'reference_projects',       weight: 10, label: 'Reference projects',       check: (p) => !!(p?.reference_projects?.trim()) },
  { key: 'keywords',                 weight: 15, label: 'Keywords & description',   check: (p) => !!(p?.keywords?.trim()) },
  { key: 'cpv_interests',            weight: 15, label: 'CPV areas of interest',    check: (p) => (p?.cpv_interests || []).some(isUsableCpv) },
  { key: 'procurement_types',        weight: 5,  label: 'Procurement types',        check: (p) => (p?.procurement_types || []).length > 0 },
  { key: 'operating_countries',      weight: 10, label: 'Delivery countries',       check: (p) => (p?.operating_countries || []).length > 0 },
];
// Total weight: 100

export function computeCompleteness(profile) {
  if (!profile) return { score: 0, missing: FIELDS.map((f) => ({ label: f.label, key: f.key })) };
  let earned = 0;
  const missing = [];
  for (const f of FIELDS) {
    if (f.check(profile)) {
      earned += f.weight;
    } else {
      missing.push({ label: f.label, key: f.key });
    }
  }
  return { score: earned, missing };
}

export function useProfileCompleteness(profile) {
  return computeCompleteness(profile);
}
